<div
  [rivTooltip]="getTooltip()"
  class="chip"
  [class.invalid]="invalid"
  [class.disabled]="disabled"
  [class.focused]="focused"
  [class.square-chip]="squareChip"
>
  <span class="text" [class.square-chip]="squareChip">{{ text }}</span>
  <span class="subtext" *ngIf="!!subtext">{{ subtext }}</span>
  <riv-icon
    *ngIf="!disabled && removable"
    name="X"
    size="16"
    class="icon"
    (click)="remove.emit()"
  ></riv-icon>
</div>
